<!--
 * @Author:
 * @LastEditTime: 2024-07-02 10:21:09
 * @Description: 承包商单位档案管理
-->
<template>
  <el-card class="h-full">
    <div class="w-full h-full" v-if="currentComp === 'TABLE'">
      <div class="flex mb-20px mr-10px">
        <div>
          <el-input
            size="small"
            class="mr-10px !w-54"
            placeholder="请输入单位名称、单位负责人"
            v-model="searchData.orgNameOrOrgLeader"
            clearable
          ></el-input>
          <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
          <el-button size="small" @click="resetSearch">重置</el-button>
        </div>
      </div>
      <el-table :data="dataList" border :height="tableHeight" stripe v-loading="tableLoading">
        <el-table-column label="单位名称" prop="orgName" show-overflow-tooltip></el-table-column>

        <el-table-column
          label="单位负责人"
          prop="orgLeader"
          width="220"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="联系电话"
          prop="phoneNumber"
          width="140"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="单位状态" prop="status" width="200">
          <template slot-scope="scope">
            <el-tag size="mini" :type="unitStatusTypes(scope.row.status)">{{
              unitStatusMap(scope.row.status)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="340">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttons(scope.row)" />
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        @size-change="tableSizeChange"
        @current-change="tableCurrentChange"
        :current-page.sync="pageConfig.SkipCount"
        :page-size.sync="pageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="totalCount"
        class="float-right mt-20px ml-20px"
      ></el-pagination>
    </div>
  </el-card>
</template>

<script>
import utils from '@/components/safety/enumField/utils'
import PanelMixins from '@/assets/js/safety/PanelMixins'
import { ContractorApi } from '@wiz-api/contractor-management'
import ContractForm from '@/components/safety/WizSafetyPage/unit/ContractForm'
import BaseInfo from '@/components/safety/WizSafetyPage/unit/BaseInfo'
import AccidentEventInfo from '@/components/safety/WizSafetyPage/unit/AccidentEventInfo'
import ApplicantsInfo from '@/components/safety/WizSafetyPage/unit/ApplicantsInfo'
import InspectRecordsInfo from '@/components/safety/WizSafetyPage/unit/InspectRecordsInfo'
import RelateProjectInfo from '@/components/safety/WizSafetyPage/unit/RelateProjectInfo'
import TicketsFiles from '@/components/safety/WizSafetyPage/unit/TicketsFiles'
import { unitStatusTypes, workFlowStatusTypes } from '@/components/safety/enumField/enumTypeMethods'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import ApprovalFlowDialog from '@/components/safety/ApprovalFlow/ApprovalFlowDialog'
import qs from 'qs'

const contractorApi = new ContractorApi()
const viewAccount = () => {
  return import('../components/ViewAccount')
}
export default {
  name: 'unit-files',
  mixins: [PanelMixins],
  components: {
    TableOperateButton,
  },
  data() {
    return {
      accountDialog: false,
      // 当前流程状态
      currentStatus: null,
      blackList: [
        { code: true, displayName: '是' },
        { code: false, displayName: '否' },
      ],
      approvalFlowDialog: false,
      visible: false,
      cardLoading: false,
      checkResultForm: {
        isPass: true,
        approve: '',
      },
      flowTaskId: null,
      rowAccountId: '',
      // 当前详情页面内容存储字段， 比如 unitFilesPanel 代表单位档案页面
      currentPanelPageName: 'unitFilesPanel',
      // 存储在localStorage的面板列表
      safetyPanelObj: {},
      pageType: 'create',
      unitStatusList: [],
      workFlowStatusList: [],
      selectionData: [],
      contractId: null,
      activeModule: '0',
      moduleList: [
        {
          module: '0',
          moduleName: '基本信息',
          checked: true,
        },
        {
          module: '1',
          moduleName: '申报人员名册',
          checked: true,
        },
        {
          module: '2',
          moduleName: '关联项目',
          checked: true,
        },
        // {
        //   module: '3',
        //   moduleName: '事故事件',
        //   checked: true,
        // },
        // {
        //   module: '4',
        //   moduleName: '巡检记录',
        //   checked: true,
        // },
        // {
        //   module: '5',
        //   moduleName: '两票档案',
        //   checked: true,
        // },
      ],
      saveLoading: false,
      dialogBlackShow: false,
      FormData: {
        evaluationOpinions: '',
      },
      rulesForm: {
        evaluationlevel: [
          { required: true, message: '请选择等级评价', trigger: ['blur', 'change'] },
        ],
      },
      dialogShow: false,
      currentComp: 'TABLE',
      tableLoading: false,
      dataList: [],
      totalCount: 0,
      searchData: {
        isBlock: undefined,
        orgNameOrOrgLeader: '',
        status: '',
        workflowStatus: null,
      },
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      constractFormData: {
        orgName: '',
        orgShortName: '',
        orgLeader: '',
        phoneNumber: '',
        idCard: '',
        email: '',
        status: 0,
        profileTemplateId: '',
        contractorPersonnelId: undefined,
        ownerdSpecialtyId: '',
      },
    }
  },
  created() {
    utils.getDataCategory(
      [
        'ContractorManagement.DataCategory.IncomingfactoryStatus',
        'ContractorManagement.DataCategory.WorkflowStatus',
      ],
      ['unitStatusList', 'workFlowStatusList'],
      this
    )
    this.getList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    unitStatusTypes() {
      return (val) => {
        return unitStatusTypes(val)
      }
    },
    workFlowStatusTypes() {
      return (val) => {
        return workFlowStatusTypes(val)
      }
    },
    unitStatusMap() {
      return (val) => {
        return (
          this.unitStatusList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    workFlowStatusMap() {
      return (val) => {
        return (
          this.workFlowStatusList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    buttons() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleDetail(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          // {
          //   text: '编辑',
          //   click: () => {
          //     return this.handleDetail(val, 'update')
          //   },
          //   // 流程状态待提交，已完成和被驳回，允许编辑
          //   isShow:
          //     this.$hasAccess('update') &&
          //     (val.workflowStatus === 0 ||
          //       val.workflowStatus === 3 ||
          //       (val.status === 1 && val.workflowStatus === 2)),
          // },
        ]
      }
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      return _.get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  methods: {
    viewAccount(row) {
      this.rowAccountId = row.leaderAccountRelationId
      this.accountDialog = true
    },
    // 前往模板页面
    goTemplatePage() {
      this.dialogShow = false
      this.$router.push('template')
    },
    // 返回页面
    handleBack() {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = 'TABLE'
      })
    },
    // 保存承包商
    handleSave() {
      this.$refs.contractForm.handleSave()
    },
    // 调用接口-保存承包商
    async save(data) {
      if (!data.id) {
        this.saveLoading = true
        const [err, res] = await contractorApi.create({ body: data })
        if (!err) {
          this.dialogShow = false
          this.getList()
        }
        this.saveLoading = false
      } else {
        this.saveLoading = true
        const [error, res] = await contractorApi.update(data.id, { body: data })
        if (!error) {
          this.dialogShow = false
          this.getList()
        }
        this.saveLoading = false
      }
    },
    // 加入黑名单
    async handleSubmit() {
      if (!this.FormData.evaluationlevel) {
        this.$message({
          showClose: true,
          message: '请选择评价等级',
          type: 'warning',
        })
        return
      }
      const filterData = []
      this.selectionData.forEach((item) => {
        if (!item.isBlock) {
          filterData.push(item.id)
        }
      })
      const data = filterData.map((item) => {
        return {
          ...this.FormData,
          relatedId: item,
          status: 3,
        }
      })
      const [error, res] = await contractorApi.statusMany({ body: data })
      if (!error) {
        this.$message({
          showClose: true,
          message: '加入黑名单成功',
          type: 'success',
        })
        this.dialogBlackShow = false
        this.getList()
      }
    },
    // 返回
    handleCancel() {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = 'TABLE'
      })
    },
    // create 新增 addBlack 加入黑名单
    handleAdd(type) {
      this.pageType = 'create'
      if (type === 'create') {
        // 新增
        this.constractFormData = this.$options.data().constractFormData
        this.dialogShow = true
        this.$nextTick(() => {
          this.$refs.contractForm.$refs.form.resetFields()
        })
      } else {
        if (this.selectionData?.length === 0) {
          this.$message({
            showClose: true,
            message: '请选择记录',
            type: 'warning',
          })
          return
        }
        const filterData = []
        this.selectionData.forEach((item) => {
          if (!item.isBlock) {
            filterData.push(item.id)
          }
        })
        if (filterData.length === 0) {
          this.$message({
            showClose: true,
            message: '请选择非黑名单记录',
            type: 'warning',
          })
          return
        }
        // 加入黑名单
        this.dialogBlackShow = true
        this.$nextTick(() => {
          this.$refs.formBlack.resetFields()
        })
      }
    },
    // 移除黑名单
    async handleRemove() {
      const filterData = []
      if (this.selectionData.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择记录',
          type: 'warning',
        })
        return
      }
      this.selectionData.forEach((item) => {
        if (item.isBlock) {
          filterData.push(item.id)
        }
      })
      if (filterData.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择有效的黑名单记录',
          type: 'warning',
        })
        return
      }
      this.$confirm('确认移除黑名单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await contractorApi.removeBlackRecord({ body: filterData })
          if (!err) {
            this.$message({
              showClose: true,
              message: '移除黑名单成功',
              type: 'success',
            })
            this.getList()
          }
        })
        .catch(() => {})
    },
    /**
     * 编辑/详情
     * @param {*} row 行数据
     * @param {*} type 操作类型 update 编辑 detail 详情
     */
    async handleDetail(row, type) {
      if (type === 'read') {
        this.$router.push({
          path: `${this.basePath}/contractor-management-sm/one-book-one-team/info`,
          query: {
            workPermitId: row.id,
            orgId: row.orgId,
            orgName: encodeURIComponent(row.orgName),
          },
        })
      }
      this.pageType = type
      this.contractId = row.id
      if (type === 'update') {
        // 获取当前流程状态
        this.currentStatus = row.status
        // 获取承包商数据
        const [err, res] = await contractorApi.get(row.id)
        if (!err) {
          this.constractFormData = this.$options.data().constractFormData
          this.constractFormData = res
          this.dialogShow = true
        }
      } else {
        this.currentComp = null
        this.$nextTick(() => {
          this.currentComp = 'DETAIL'
        })
      }
    },
    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getList()
    },
    resetSearch() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getList()
    },
    // 获取列表
    async getList() {
      this.tableLoading = true
      this.selectionData = []
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
      }
      if (window.__POWERED_BY_QIANKUN__) {
        // 低代码
        const instance = axios.create()
        instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
        const token = localStorage.getItem('authorization')
        instance.defaults.headers.common.Authorization = `Bearer ${token}`
        const res = await instance.get(
          `/api/contractor-management/contractors/paged-list-query?${qs.stringify({
            ...data,
            ...this.searchData,
          })}`
        )
        if (res.status === 200 && res.data) {
          this.dataList = res.data.items || []
          this.totalCount = res.data.totalCount || 0
        }
        this.tableLoading = false
        return
      }
      const [error, result] = await contractorApi.pagedListQuery({
        ...data,
        ...this.searchData,
      })
      if (!error) {
        if (result.items) {
          this.dataList = result.items || []
          this.totalCount = result.totalCount || 0
        }
      }
      this.tableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}

.title {
  color: var(--textColor);
  position: relative;
  &::before {
    position: absolute;
    content: '';
    width: 2px;
    height: 70%;
    left: -8px;
    top: 4px;
    background-color: var(--systemColor);
  }
}

.detail-height {
  height: calc(100% - 52px);
}
</style>
